/** Listado de usuarios del propio comité (read-only).
 *
 * Para alta / edición / reset de password, eso vive en la Console SaaS
 * (`/superadmin/empresas/{id}/usuarios`) y solo lo opera Nicolás.
 */
import { apiRequest } from "../../lib/api";

export interface UsuarioRead {
  id: number;
  empresa_id: number;
  nombre: string;
  email: string;
  username: string;
  role: string;
  cargo: string | null;
  is_active: boolean;
  is_superadmin: boolean;
  created_at: string;
  updated_at: string;
}

export function listarUsuarios(only_active = true): Promise<UsuarioRead[]> {
  const qs = only_active ? "" : "?only_active=false";
  return apiRequest<UsuarioRead[]>(`/api/v1/usuarios${qs}`);
}
